import Polyglot from 'node-polyglot';
import phrases from './messages';

/** todo define environment lang value */
var lang = document.documentElement.lang;
var DEFAULT_LANG = 'en_US';
var locale = (lang || DEFAULT_LANG).split('_')[0];
var polyglot = new Polyglot({ phrases: phrases, locale: locale });

var translator = function translator(token, options) {
	return polyglot.t(token, options);
};

export default translator;


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/index.js